import React, { useState } from 'react';
import { Icon } from '@oliasoft-open-source/react-ui-library';
import { OffsetWells } from 'src/views/well-details/drawer/offset-wells/offset-wells';
import { GenericDrawer } from 'client/common/components/generic-drawer/generic-drawer';
import { casingRenderTab } from 'src/common/components/casing-renderer/casing-renderer-tab';
import { getNotesTab } from 'src/common/components/notes/get-notes-tab';
import { getCurrencyTab } from 'src/common/components/currency-tab/get-currency-tab';
import { NoteModule } from 'src/enums/notes-enums';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const RawCostSetupDrawer = () => {
  const [drawerWidth, setDrawerWidth] = useState(400);

  const drawerProps = {
    width: drawerWidth,
    defaultTabIndex: 1,
    tabs: [
      {
        icon: <Icon icon="target" />,
        content: <OffsetWells />,
      },
      casingRenderTab,
      getNotesTab(NoteModule.CostSetup),
      getCurrencyTab(),
    ].filter(Boolean),
    onResize: (width) => setDrawerWidth(width),
  };
  return <GenericDrawer {...drawerProps} />;
};

export const CostSetupDrawer = withErrorBoundary(RawCostSetupDrawer, {
  isRightSideBar: true,
});
